module.exports = __webpack_public_path__ + "img/welcome.e51040b3.png";